"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    "aria-hidden": "true",
    className: className,
    fill: "none",
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 167 126",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M157.176 98.816c0-9.106-18.798-9.14-22.247-8.795l-117.93 22.11c-7.5 1.5-1.777 18.052 42.5 12.5 39.606-4.965 97.677-9.777 97.677-25.815z",
    fill: "#404040",
    fillOpacity: ".25"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M144.759 24.316 39.735 4.14c6.898 3.794 21.109 21.419 20.695 55.358-.414 33.938-14.659 52.08-21.212 57.427l105.541-20.695c3.622-1.035 18.832-2.587 21.729-31.559 2.898-28.972-13.278-38.974-21.729-40.354z",
    fill: "#FF0101"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m34 118.631 117-24c6.4-2.8 10.667-10.833 12-14.5l-107 10.5c-1 2.667-3.7 9.7-6.5 16.5-2.8 6.8-11.5 10.5-15.5 11.5z",
    fill: "#999595",
    fillOpacity: ".25"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    clipRule: "evenodd",
    d: "M30.94 121.062c16.858 0 30.524-27.1 30.524-60.531C61.464 27.101 47.798 0 30.94 0S.416 27.1.416 60.531c0 33.43 13.666 60.531 30.524 60.531zm-1.495-10.871c-4.86 2.064-.53 7.121 4.418 6.708 4.949-.412 9.426-6.364 11.046-9.288l-10.604 1.548-4.86 1.032z",
    fill: "url(#a)",
    fillRule: "evenodd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    clipRule: "evenodd",
    d: "M30.94 121.062c16.858 0 30.524-27.1 30.524-60.531C61.464 27.101 47.798 0 30.94 0S.416 27.1.416 60.531c0 33.43 13.666 60.531 30.524 60.531zm-1.495-10.871c-4.86 2.064-.53 7.121 4.418 6.708 4.949-.412 9.426-6.364 11.046-9.288l-10.604 1.548-4.86 1.032z",
    fill: "#EAEAEA",
    fillRule: "evenodd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49 105.631c8-11.5 10.5-38.5 10.5-51-1.5-17-6-28.5-6-29s0-8.5-10.5-8.5-20 16.5-20 46 18 54 26 42.5z",
    fill: "#C4C4C4",
    fillOpacity: ".1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.002 6.734c-.944 0-2.404-.231-3.337.069-.934.3-1.673 1.18-2.546 1.616-2.109 1.055-3.17 2.724-4.798 4.352-2.565 2.565-4.213 6.189-5.9 9.322-1.906 3.54-2.569 7.857-3.922 11.645C9.584 36.302 9 39.5 8.5 42M8 45.5l-.5 4",
    stroke: "#00754A",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M55.307 101.791c1.193-2.291 2.566-4.529 3.406-6.966.68-1.97 1.65-4.124 1.908-6.185.243-1.94 1.14-3.816 1.14-5.75 0-.856.46-1.54.46-2.407 0-.59.136-1.713.462-2.202M48.623 112.624c.722-1.684 1.958-2.689 2.817-4.149.547-.931 1.21-1.891 1.793-2.766M147.708 26.598c3.749.572 6.508 3.907 8.441 6.914 1.181 1.836 2.279 4.13 2.814 6.271",
    stroke: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59.464 60.531c0 16.47-3.37 31.281-8.726 41.901-5.413 10.736-12.526 16.63-19.798 16.63-7.272 0-14.384-5.894-19.798-16.63-5.355-10.62-8.726-25.431-8.726-41.901 0-16.47 3.37-31.281 8.726-41.901C16.556 7.895 23.668 2 30.94 2c7.272 0 14.385 5.895 19.798 16.63 5.356 10.62 8.726 25.431 8.726 41.901z",
    stroke: "#F8F8F8",
    strokeWidth: "4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.5 46.5c2-4.4 7.167-8.167 9.5-9.5 3-1.5 5.5-2 9.5-1.5 2.53.316 7 2 9 3 2.608 1.304 7.5 4.5 10 8 1.718 2.406 3.222 5 4 8.5 1 4.5 1 5.5.75 9.75s-.965 7.843-1.6 9.75c-.636 1.907-2.15 6-5.15 9.5-2.831 3.303-7.302 7.074-12.5 9.5-11 5.133-15 3.95-17 3.45s-5-1.45-8-4.45c-4.5-5.5-3.833-15.833-3.5-23 .667-5.833.682-13.5 5-23z",
    fill: "#006241"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110.935 92.573c2.374-.04 4.56-.856 6.47-2.289 1.547-1.16 3.155-1.926 4.636-3.218 1.101-.961 2.126-2.109 2.811-3.38.395-.734 1.116-1.116 1.557-1.778",
    stroke: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "a",
    x1: "22.145",
    x2: "192.939",
    y1: "107.611",
    y2: "-34.787"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#F1F0ED"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: ".88",
    stopColor: "#F4F4F1",
    stopOpacity: "0"
  }))));
};